import React from 'react';
import css from './BatchSentItemsHeader.scss';

export default class BatchSentItemHeader extends React.Component {

    render() {

        return (
            <div className={css['heading-section']} >
                <div className={css['row']}>
                    <div className={css['arrow-send-icon']}>
                        <img src={'../images/noun_sent_1936974.png'} alt="Batch Send Icon" width={48} />
                    </div>
                    <div className={css['batch-send-title']}><p className={css['title']}>Batch Sent Items</p></div>
                </div>
            </div>
        );
    }
}
